import { useTranslation } from 'react-i18next'
import { Card, CardContent, CardHeader, Divider, Grid, Typography } from '@mui/material'
import type { ReturnPortal } from '~/model'

type Props = { returnPortal: ReturnPortal }

export const CompanyInfo = ({
  returnPortal: {
    address: {
      name: { companyName },
      address: { city, zipCode: postalCode, street, number, addition = '', countryCode },
    },
    logo,
  },
}: Props) => {
  const { t } = useTranslation()

  return (
    <Card>
      <CardHeader title={t('returnTo')} />
      <Divider />
      <CardContent>
        <Grid container direction="row" justifyContent="space-between" wrap="nowrap" size={{ xs: 12 }}>
          <Grid container direction="column" spacing={0} data-test="company-info">
            <Grid>
              <Typography variant="h5" sx={{ height: '24px', whiteSpace: 'nowrap' }}>
                {companyName}
              </Typography>
            </Grid>
            <Grid>
              <Typography>{`${street} ${number} ${addition}`}</Typography>
            </Grid>
            <Grid>
              <Typography>{`${postalCode} ${city}, ${t(`country.${countryCode}`)}`}</Typography>
            </Grid>
          </Grid>
          {logo && (
            <Grid container justifyContent="flex-end">
              <img src={`data:image/jpeg;base64,${logo}`} style={{ maxHeight: '80px', maxWidth: '300px' }} alt="Logo" />
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  )
}
